import { Link } from "react-router-dom";

export const CONTACT = {
  phone: "+1 807 907-2874",
  phoneHref: "tel:+18079072874",
  email: "info@mazesecurity.ca",
  emailHref: "mailto:info@mazesecurity.ca",
  parentBrand: "Maze Security Solutions",
  brand: "Nova Scotia Security Services",
};

export const NSLogo = ({ className = "", size = 44, dark = false, testid }) => {
  const stroke = dark ? "#F5F3EF" : "#111111";
  return (
    <Link
      to="/"
      data-testid={testid || "nav-logo"}
      className={`inline-flex items-center gap-3 ${className}`}
      aria-label={`${CONTACT.parentBrand} — ${CONTACT.brand} home`}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        className="flex-shrink-0"
      >
        <rect x="1" y="1" width="62" height="62" rx="6" fill="none" stroke={stroke} strokeWidth="2" />
        <text
          x="50%"
          y="52%"
          dominantBaseline="middle"
          textAnchor="middle"
          fontFamily="'Playfair Display', serif"
          fontWeight="700"
          fontStyle="italic"
          fontSize="34"
          fill={stroke}
        >
          M
        </text>
        <line x1="8" y1="56" x2="24" y2="56" stroke={stroke} strokeWidth="2" />
      </svg>
      <span
        className="flex sm:hidden font-serif text-[15px] tracking-tight leading-none"
        style={{ color: stroke }}
        data-testid="nav-parent-brand-mobile"
      >
        Maze Security Solutions
      </span>
      <span
        className="hidden sm:flex flex-col leading-none"
        style={{ color: stroke }}
      >
        <span
          className="font-serif text-[17px] tracking-tight"
          data-testid="nav-parent-brand"
        >
          Maze Security Solutions
        </span>
        <span className="mt-1.5 font-mono text-[10px] uppercase tracking-[0.22em] opacity-70">
          Nova Scotia Security Services
        </span>
      </span>
    </Link>
  );
};
